import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { LineChart, axisClasses } from '@mui/x-charts';
import { ChartsTextStyle } from '@mui/x-charts/ChartsText';
import Title from '../common/Title';

// Generate Sales Data
function createData(time: string, amount?: number): { time: string; amount: number | null } {
	return { time, amount: amount ?? null };
}

const data = [
	createData('00:00', 0),
	createData('03:00', 300),
	createData('06:00', 600),
	createData('09:00', 800),
	createData('12:00', 1500),
	createData('15:00', 2000),
	createData('18:00', 2400),
	createData('21:00', 2400),
	createData('24:00'),
];

export default function Chart() {
	const theme = useTheme();

	return (
		<React.Fragment>
			<Title>Today</Title>
			<div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
				<LineChart
					dataset={data}
					margin={{
						top: 16,
						right: 20,
						left: 70,
						bottom: 30,
					}}
					xAxis={[
						{
							scaleType: 'point',
							dataKey: 'time',
							tickNumber: 2,
							tickLabelStyle: theme.typography.body2 as ChartsTextStyle,
						},
					]}
					yAxis={[
						{
							label: 'Sales ($)',
							labelStyle: {
								...(theme.typography.body1 as ChartsTextStyle),
								fill: theme.palette.text.primary,
							},
							tickLabelStyle: theme.typography.body2 as ChartsTextStyle,
							max: 2500,
							tickNumber: 3,
						},
					]}
					series={[
						{
							dataKey: 'amount',
							showMark: false,
							color: theme.palette.primary.light,
						},
					]}
					sx={{
						[`.${axisClasses.root} line`]: { stroke: theme.palette.text.secondary },
						[`.${axisClasses.root} text`]: { fill: theme.palette.text.secondary },
						[`& .${axisClasses.left} .${axisClasses.label}`]: {
							transform: 'translateX(-25px)',
						},
					}}
				/>
			</div>
		</React.Fragment>
	);
}
